// src/components/YourPath/AssistanceItem.js
import React, { useState } from "react";
import { Icon, Confirm, Modal } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { AssistanceForm } from "../AssistanceForm";
import { useAuth } from "../../../../hooks";
import { AssistanceApi } from "../../../../api";
import { AssistantEducaChat } from "../../../AssistantEduca";
import { Assistant_createthread } from "../../../../api/AssistantEducaAPI";
import "./AssistanceItem.scss";

const assistanceController = new AssistanceApi();

export function AssistanceItem(props) {
  const { assistance, onReload, canEdit } = props;
  const { accessToken } = useAuth();

  // Estados para los diferentes modales
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showChat, setShowChat]   = useState(false);
  const [threadId, setThreadId]   = useState(null);

  // Alternar modal de edición
  const onOpenCloseModal = () => setShowModal((prev) => !prev);

  // Alternar confirm de eliminación
  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  // Alternar modal de chat
  const onOpenCloseChat = async () => {
    if (!showChat && !threadId) {
      try {
        const newThreadId = await Assistant_createthread(
          accessToken,
          assistance._id
        );
        setThreadId(newThreadId);
      } catch (error) {
        console.error("Error al crear el thread:", error);
      }
    }
    setShowChat((prev) => !prev);
  };

  // Eliminar asistencia
  const onDelete = async () => {
    try {
      await assistanceController.deleteAssistance(
        accessToken,
        assistance._id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {/* Tarjeta principal */}
      <div className="e-card-assistance">
        <div className="assistance-info">
          <h3 className="assistance-title">{assistance.title}</h3>
          <p className="assistance-center">{assistance.path}</p>

          <div className="assistance-buttons">
            {/* Botón "Chat" (siempre visible) */}
            <button className="btn-icon e-button-chat" onClick={onOpenCloseChat}>
              <Icon name="comments" />
            </button>

            {/* Botón "Editar" (solo si canEdit === true) */}
            {canEdit && (
              <button className="btn-icon e-button-info" onClick={onOpenCloseModal}>
                <Icon name="pencil" />
              </button>
            )}
          </div>
        </div>

        {/* Imagen/Avatar del asistente */}
        <div className="assistance-image">
          <img src={assistance.miniature} alt={assistance.title} />
        </div>
      </div>

      {/* Modal para editar la asistencia (solo si canEdit) */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Editar Asistente IA"
        size="small"
      >
        <AssistanceForm
          assistance={assistance}
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>

      {/* Confirm para eliminar la asistencia */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Seguro que quieres eliminar "${assistance.title}"?`}
        size="mini"
      />

      {/* Modal con el chat IA */}
      <Modal
        open={showChat}
        onClose={onOpenCloseChat}
        closeIcon
        size="small"
        className="chatbot-modal"
      >
        <Modal.Content scrolling>
          <div className="institution-publi">
            <AssistantEducaChat
              assistantId={assistance._id}
              avatarImg={assistance.miniature}
              saludo={assistance.title}
              threadId={threadId}
            />
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
}
